import { render, staticRenderFns } from "./ControlloAlloggiTabelloneCronologiaView.vue?vue&type=template&id=09753179&"
import script from "./ControlloAlloggiTabelloneCronologiaView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiTabelloneCronologiaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports